(function () {
  'use strict';

  angular.module('app').component('creditPaymentTermDetail', creditPaymentTermDetail());

  function creditPaymentTermDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onCreditPaymentTermSaved: '&',
        onCreditPaymentTermCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: CreditPaymentTermComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/credit-payment-terms/credit-payment-term-detail/credit-payment-term-detail.component.html',
    };
  }

  CreditPaymentTermComponent.$inject = ['UtilService', 'CreditPaymentTermService'];

  function CreditPaymentTermComponent(UtilService, CreditPaymentTermService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // private properties
    // -----------------------
    const fieldsDefinition = ['name', 'days'];

    vm.$onInit = function () {
      if (vm.item.id) {
        // view / edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // new
        vm.createMode = true;
      }
    };

    // public methods
    // -----------------------
    vm.editCreditPaymentTerm = function () {
      vm.editMode = true;
      vm.viewMode = false;
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    // Create/Update
    vm.saveCreditPaymentTerm = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        CreditPaymentTermService.saveCreditPaymentTerm(vm.item).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // Success
            if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            }

            // setItemOptions(response); // use only if keep in the same page
            vm.onCreditPaymentTermSaved({ item: response, mode: vm.mode }); // , editMode: vm.editMode
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = false;
          }

          vm.sendingForm = false;
        });
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      // if (vm.editMode){
      //     vm.cancelEdit();
      //     return;
      // }

      vm.onCreditPaymentTermCanceled();
    };

    vm.openTranslations = function () {
      CreditPaymentTermService.openCreditPaymentTermTranslations(vm.item, vm.additionalLanguages);
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editCreditPaymentTerm();
      }

      vm.originalItem = angular.copy(item); // store server data
    }
  }
})();
